var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"socialMarketingImage",staticClass:"social-marketing-image",class:{
    'social-marketing-image--no-image': !_vm.image,
  },style:(_vm.imageStyle)},[_c('div',{staticClass:"image-dragger",class:{ 'image-dragger--edit-mode': _vm.editMode },style:(_vm.filterStyle),on:{"mousedown":_vm.onMousedown,"mousemove":_vm.onMouseMove}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }